module.exports = __webpack_public_path__ + "static/media/1.9a2438e3.png";